import BaseModel from '../core/BaseModel';
import VehicleCategoryModel from '@/models/VehicleCategoryModel'

import constants from '../core/Constants';

var getContants = constants.getConstans();

export default class CarForRentModel extends BaseModel {

    constructor() {
        super({
                name: "car_for_rent",
                tableName: 'car_for_rent',
                label: "Car For Rent"
            },
            {
                check_box: {
                    name: "check_box",
                    label: " ",
                    type: "Computed",
                    custom: 'CheckBoxSelect',
                    computed: (data) => {
                        data.stt = '';
                    },
                    filter: {}
                    // display: { list: true, add: false, edit: false }
                },
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                license_plate_number: {
                    name: 'license_plate_number',
                    type: "String",
                    label: 'License plate number',
                    filter: { type: 'input', match: 'contains' },
                },
                vehicle_category_id: {
                    name: "vehicle_category_id",
                    label: "Vehicle category",
                    type: "Computed",
                    models: new VehicleCategoryModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                
               
                    class:"left",
                    width : 8,
                },
                color: {
                    name: "color",
                    label: "Color",
                    type: "Computed",
                    filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.visit = '';
                    },
                    class: "left",
                },
                valid_until: {
                    name: 'valid_until',
                    type: "Custom",
                    label: 'Valid until',
                    filter: { type: 'DateRange', match: 'contains' },
                    class: 'left',
                },
                visit: {
                    name: "visit",
                    label: "No. of rental",
                    type: "Computed",
                    computed: (data) => {
                        data.visit = '';
                    },
                    class: "left",
                },
                status: {
                    name: "status",
                    label: "Status",
                    type: "String",
                    options: getContants.CAR_FOR_RENT_STATUS,
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "left",
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "left",
                },
                updated_by_key: {
                    name: "updated_by",
                    label: "Updated by",
                    type: "Computed",
                    computed: (data) => {
                        data.updated_by_key = '';
                    },
                    class: "left",
                },
                updated_at: {
                    name: 'updated_at',
                    type: "String",
                    label: 'Updated date',  
                },
                detail_get: {
                    refs:  '  obj_vehicle_category { id name bond_fee} obj_update_user { id fullname } ',
                    display: false
                },
                detail_get1: {
                    refs:  ' id color fee_fix ',
                    display: false
                },
            }
        )
    }
}
